var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[(!_vm.isIE)?_c('router-view'):_vm._e(),(_vm.isIE)?_c('block-internet-explorer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }